
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Epistexis(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Epistexis"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Bleeding from the nose, either spontaneous or induced by nose picking or trauma.
                                </p>
                                <p>Nosebleeds are common. Some 60% of people will have at least one
                                    nosebleed in their lifetime. The location of the nose in the middle of the face
                                    and the large number of blood vessels close to the surface in the lining of
                                    your nose make it an easy target for injury and nosebleeds.</p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Epistexis/1.png")} alt="onycomycosis" />
                                    </div>
                                </div>
                                <br></br>
                                <a className="links" href="https://en.wikipedia.org/wiki/Nosebleed">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Epistexis;